module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_20-b6a5b093fd627183ab65071845b047cd.png";